module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/culture-5461b6a8a5a0acd88157838c76d3fbb7.svg&quot;;"